import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { auth } from "../utils/nhost";
import './Login.css';
import { Col, Layout, Row, Typography, Button } from "antd";

import { Link } from "react-router-dom";

const { Header, Content, Footer } = Layout;
const { Text } = Typography;

const H3 = (props) => (
  <Typography.Title level={3} {...props} />
)

export const contentMinHeight = "calc(100vh - 64px - 70px)";

const LoginInner = ( props ) => {
  const [userData, setUserData] = useState({ new_password: '', error: '' });
  const history = useHistory();
  const { ticket } = useParams();

  async function handleSubmit (event) {
    event.preventDefault()
    setUserData({
      ...userData,
      error: ''
    })


    const { new_password } = userData;

    try {
      await auth.changePasswordChange(new_password, ticket);
      history.push("/");
    } catch (error) {
      console.error(
        'You have an error in your code or there are Network issues.',
        error
      )

      const { response } = error
      setUserData(
        Object.assign({}, userData, {
          error: response ? response.statusText : error.message
        })
      )
    }
  }
  return (
    <div className="login">
        <form onSubmit={handleSubmit}>
          <input
            type='password'
            id='password'
            name='password'
            minLength='3'
            value={userData.new_password}
            onChange={event =>
              setUserData({
                ...userData,
                new_password: event.target.value 
              })
            }
          />

          <Button
            type="primary"
            htmlType="submit"
            data-cy="loginpage-button-submit"
          >
            Set New Password
          </Button>

          {userData.error && <p className='error'>Error: {userData.error}</p>}
        </form>
    </div>
  );
};

export default function () {
  const title = "Change Password";
  return (
    <Layout>
       <Header
          style={{
            boxShadow: "0 2px 8px #f0f1f2",
            zIndex: 1,
            overflow: "hidden",
          }}
        >
        <Row justify="space-between">
          <Col span={6}>
            <Link to="/">Aquire</Link>
          </Col>
          <Col span={12}>
            <H3
              style={{
                margin: 0,
                padding: 0,
                textAlign: "center",
                lineHeight: "64px"
              }}
              data-cy="layout-header-title"
            >
                { title }
            </H3>
          </Col>
          <Col span={6} style={{ textAlign: "right" }} />
          </Row>
       </Header>
        <Content style={{ minHeight: contentMinHeight }}>
          <LoginInner />
        </Content>
      <Footer>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between"
          }}
        >
          <Text>
            Copyright &copy; {new Date().getFullYear()} {"Aquire"}. All
            rights reserved.
          </Text>
        </div>
      </Footer>
    </Layout>
  )
}

